import React from "react";
import { State } from "../types";
import { Habit, Context } from "../types";
import { AnimatedScore } from "../components/AnimatedScore";
import { HabitsSection } from "../components/HabitsSection";
import { ContextsSection } from "../components/ContextsSection";
import { NotesSection } from "../components/NotesSection";

interface DailyViewProps {
  state: State;
  selectedDay: string;
  collapsedCategories: number[];
  pressStartTime: number | null;
  pressScale: number;
  pressedItemId: number | null;
  onHabitClick: (habit: Habit) => void;
  onContextClick: (context: Context) => void;
  onAddHabit: () => void;
  onNoteChange: (date: string, note: string) => void;
  onCategoryToggle: (categoryId: number) => void;
  onPressStart: (
    item: Habit | Context,
    event: React.MouseEvent | React.TouchEvent,
  ) => void;
  onPressMove: (event: React.MouseEvent | React.TouchEvent) => void;
  onPressEnd: (item: Habit | Context) => void;
  onPressCancel: () => void;
}

export const DailyView: React.FC<DailyViewProps> = ({
  state,
  selectedDay,
  collapsedCategories,
  pressStartTime,
  pressScale,
  pressedItemId,
  onHabitClick,
  onContextClick,
  onAddHabit,
  onNoteChange,
  onCategoryToggle,
  onPressStart,
  onPressMove,
  onPressEnd,
  onPressCancel,
}) => {
  const totalScore =
    state.days.find((day) => day.date === selectedDay)?.score || 0;
  const currentDayNote =
    state.days.find((day) => day.date === selectedDay)?.notes || "";

  return (
    <div style={{ paddingBottom: "100px" }}>
      {/* Score display */}
      <AnimatedScore value={totalScore} />

      {/* Habits section */}
      <HabitsSection
        habits={state.habits}
        days={state.days}
        categories={state.categories}
        selectedDay={selectedDay}
        greyOutEnabled={state.greyOutEnabled}
        categoriesEnabled={state.categoriesEnabled}
        sortOrder={state.sortOrder}
        collapsedCategories={collapsedCategories}
        pressStartTime={pressStartTime}
        pressScale={pressScale}
        pressedItemId={pressedItemId}
        onHabitClick={onHabitClick}
        onAddHabit={onAddHabit}
        onCategoryToggle={onCategoryToggle}
        onPressStart={onPressStart}
        onPressMove={onPressMove}
        onPressEnd={onPressEnd}
        onPressCancel={onPressCancel}
      />

      {/* Contexts section */}
      {state.contextsEnabled && (
        <ContextsSection
          contexts={state.contexts}
          days={state.days}
          selectedDay={selectedDay}
          pressStartTime={pressStartTime}
          pressScale={pressScale}
          pressedItemId={pressedItemId}
          onContextClick={onContextClick}
          onPressStart={onPressStart}
          onPressMove={onPressMove}
          onPressEnd={onPressEnd}
          onPressCancel={onPressCancel}
        />
      )}

      {/* Notes section */}
      {state.notesEnabled && (
        <NotesSection
          selectedDay={selectedDay}
          initialNote={currentDayNote}
          onNoteChange={onNoteChange}
        />
      )}
    </div>
  );
};
